import "~/misc/common";
import { loader } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {

    console.log('initLpRegistrationsIndex');

    $('.datetimepicker').datetimepicker().on('dp.change', function (ev) {
      loader(true);
      $('#new_q').submit();
    });

    $('.q_date_eq label').prepend('<div class="btn-group"><a class="btn btn-default btn-xs" id="prevDay"><i class="fa fa-chevron-left"></i></a><a class="btn btn-default btn-xs" id="nextDay"><i class="fa fa-chevron-right"></i></a></span> ');

    $('#prevDay').click(function () {
      const date = $('#q_date_eq').parent().datetimepicker().data("DateTimePicker").date();
      if (date) {
        $('#q_date_eq').parent().datetimepicker().data("DateTimePicker").date(date.subtract(1, 'days'));
      }
    });

    $('#nextDay').click(function () {
      const date = $('#q_date_eq').parent().datetimepicker().data("DateTimePicker").date();
      if (date) {
        $('#q_date_eq').parent().datetimepicker().data("DateTimePicker").date(date.add(1, 'days'));
      }
    });
  }
}
